/**
 * Detect NODE_ENV equals 'development'
 */

export default process.env.NODE_ENV === 'development';
